/** ID status (enum backend MeetingScheduleStatus). */
export const SCHEDULE_STATUS = {
  NEW: 1,
  CONFIRMED: 2,
  DONE: 3,
  CANCELLED: 4,
  NO_SHOW: 5,
  PENAWARAN_ZOOM: 6,
  KONFIRMASI_HADIR: 7,
};

/** Panjang minimal report (hasil meeting) saat status Selesai. */
export const REPORT_MIN_LENGTH = 100;
